import React from 'react';

import { createClassName } from 'utils/createClassName';

import './delimiterStyles.scss';

export const DelimiterComponent: React.FC = (props) => {
  const { children } = props;

  const createDelimiterClassName = createClassName('delimiter');

  const wrapperClassName = createDelimiterClassName('wrapper');
  const contentClassName = createDelimiterClassName('content');

  return (
    <div className={wrapperClassName}>
      {children && <div className={contentClassName}>{children}</div>}
    </div>
  );
};
